import React from "react";
import AppView from "../../components/Layout/AppView";

const CustomersPage = () => {
  return <AppView>Customers Page</AppView>;
};

export default CustomersPage;
